export function ConvertToMerchantDetail(merchantDetail: any) {
  const _merchantDetail = {
    addressList: merchantDetail.addressList,
    building: merchantDetail.building,
    businessCategoryId: merchantDetail.businessCategoryId,
    country: merchantDetail.country,
    description: merchantDetail.description,
    district1: merchantDetail.district1,
    district2: merchantDetail.district2,
    email: merchantDetail.email,
    expireDateTime: merchantDetail.expireDateTime,
    facebook: merchantDetail.facebook,
    fax: merchantDetail.fax,
    floorNo: merchantDetail.floorNo,
    homeGroup: merchantDetail.homeGroup,
    homeno: merchantDetail.homeno,
    industryCode: merchantDetail.industryCode,
    isAllowDuplicateContact: merchantDetail.isAllowDuplicateContact,
    isAllowDuplicateProduct: merchantDetail.isAllowDuplicateProduct,
    isAutoApprove: merchantDetail.isAutoApprove,
    isLockPeriod: merchantDetail.isLockPeriod,
    isSample: merchantDetail.isSample,
    isSeparateRunningCreditNoteExpenseTaxInvoiceNumber: merchantDetail.isSeparateRunningCreditNoteExpenseTaxInvoiceNumber
      ? true
      : false,
    isSeparateRunningCreditNoteTaxInvoiceNumber: merchantDetail.isSeparateRunningCreditNoteTaxInvoiceNumber
      ? true
      : false,
    isSeparateRunningInvoiceTaxInvoiceNumber: merchantDetail.isSeparateRunningInvoiceTaxInvoiceNumber ? true : false,
    isSeparateRunningReceiptTaxInvoiceNumber: merchantDetail.isSeparateRunningReceiptTaxInvoiceNumber ? true : false,
    isSeparateRunningDebitNoteTaxInvoiceNumber: merchantDetail.isSeparateRunningDebitNoteTaxInvoiceNumber
      ? true
      : false,
    isVat: merchantDetail.isVat,
    lineId: merchantDetail.lineId,
    lockPeriodEndDate: merchantDetail.lockPeriodEndDate,
    logoUrl: merchantDetail.logoUrl
      ? process.env.VUE_APP_PeakBlobStorage?.toString().UrlCombine(
          "peakengine",
          `${merchantDetail.logoUrl}?${new Date().getTime()}`
        )
      : "",
    merchantBranchCode: merchantDetail.merchantBranchCode,
    merchantId: merchantDetail.merchantId,
    merchantName: merchantDetail.merchantName,
    merchantNameEng: merchantDetail.merchantNameEng,
    merchantNameTh: merchantDetail.merchantNameTh,
    merchantTaxId: merchantDetail.merchantTaxId,
    merchantType: merchantDetail.merchantType,
    no: merchantDetail.no,
    package: merchantDetail.package,
    payrollContactId: merchantDetail.payrollContactId,
    phone: merchantDetail.phone,
    postCode: merchantDetail.postCode,
    province: merchantDetail.province,
    registeredDate: merchantDetail.registeredDate,
    revenueDepartmentContactId: merchantDetail.revenueDepartmentContactId,
    road: merchantDetail.road,
    roomNo: merchantDetail.roomNo,
    sendBranch: merchantDetail.sendBranch,
    sendBuilding: merchantDetail.sendBuilding,
    sendCountry: merchantDetail.sendCountry,
    sendDistrict1: merchantDetail.sendDistrict1,
    sendDistrict2: merchantDetail.sendDistrict2,
    sendFloorNo: merchantDetail.sendFloorNo,
    sendHomeGroup: merchantDetail.sendHomeGroup,
    sendHomeNo: merchantDetail.sendHomeNo,
    sendNo: merchantDetail.sendNo,
    sendPostcode: merchantDetail.sendPostcode,
    sendProvince: merchantDetail.sendProvince,
    sendRoad: merchantDetail.sendRoad,
    sendRoomNo: merchantDetail.sendRoomNo,
    sendSoi: merchantDetail.sendSoi,
    soi: merchantDetail.soi,
    ssoContactId: merchantDetail.ssoContactId,
    stampUrl: merchantDetail.stampUrl
      ? process.env.VUE_APP_PeakBlobStorage?.toString().UrlCombine(
          "peakengine",
          `${merchantDetail.stampUrl}?${new Date().getTime()}`
        )
      : "",
    status: merchantDetail.status,
    taxStatusType: merchantDetail.taxStatusType,
    vatRegistrationDate: merchantDetail.vatRegistrationDate,
    verifiedDatetime: merchantDetail.verifiedDatetime,
    website: merchantDetail.website,
    verificationStatus: merchantDetail.verificationStatus,
  };
  return _merchantDetail;
}

export function CoventToConnectPeakWithMerchantIdModel(settingConnectPeakModelData: any) {
  let settingConnectPeakModel;
  if (settingConnectPeakModelData) {
    settingConnectPeakModel = {
      merchantId: settingConnectPeakModelData.merchantId ? settingConnectPeakModelData.merchantId : 0,
      isPeakTaxConnected: settingConnectPeakModelData.isPeakTaxConnected
        ? settingConnectPeakModelData.isPeakTaxConnected
        : false,
      isPeakPayrollConnected: settingConnectPeakModelData.isPeakPayrollConnected
        ? settingConnectPeakModelData.isPeakPayrollConnected
        : false,
      updateDateTime: settingConnectPeakModelData.updateDateTime ? settingConnectPeakModelData.updateDateTime : null,
      updateUserId: settingConnectPeakModelData.updateUserId ? settingConnectPeakModelData.updateUserId : 0,
    };
  }
  return settingConnectPeakModel;
}

export function ConvertToMerchantAddressList(merchantAddressList: Array<any>) {
  const _merchantAddressList: Array<any> = [];

  merchantAddressList.forEach((merchantAddress) => {
    _merchantAddressList.push({
      id: merchantAddress.id,
      name: merchantAddress.name,
      building: merchantAddress.building,
      roomNo: merchantAddress.roomNo,
      floorNo: merchantAddress.floorNo,
      no: merchantAddress.no,
      homeGroup: merchantAddress.homeGroup,
      homeNo: merchantAddress.homeNo,
      soi: merchantAddress.soi,
      road: merchantAddress.road,
      district1: merchantAddress.district1,
      district2: merchantAddress.district2,
      province: merchantAddress.province,
      country: merchantAddress.country,
      postCode: merchantAddress.postCode,
      addressName: merchantAddress.addressName,
      language: merchantAddress.language,
    });
  });

  return _merchantAddressList;
}
